export default "__VITE_ASSET__C$ugc$bE__"